
import { defineComponent } from 'vue';

import Main from './views/Main.vue';

export default defineComponent({
    components: {
        Main
    },
    setup() {},
});
